import { hatPartner, partnerLogoPfad } from '@k4ia/shared'

/**
 * „powered by <Partner>" unter dem, was K4ia zu einem Showcase erzählt — nur
 * bei Showcases mit gepflegtem Partner (Admin → Showcase → „Powered by").
 * Mit Logo steht das Logo, sonst der Name; eins von beiden genügt. Auf weißem Grund, weil Logos
 * meist für hellen Hintergrund gemacht sind.
 */
export function PoweredBy({
  showcase,
  gross = false,
  className = '',
}: {
  showcase: { partnerName: string; partnerLogoKey: string | null } | null | undefined
  /** Für den Präsentationsbildschirm: ein paar Meter Abstand. */
  gross?: boolean
  className?: string
}) {
  if (!showcase || !hatPartner(showcase)) return null
  const name = showcase.partnerName.trim()
  return (
    <span
      className={`inline-flex items-center rounded-full bg-white text-neutral-800 shadow-[var(--shadow-card)] ${
        gross ? 'gap-4 px-6 py-3 text-xl' : 'gap-2 px-3 py-1 text-xs'
      } ${className}`}
    >
      <span className="font-mono uppercase tracking-wider text-neutral-500">powered by</span>
      {showcase.partnerLogoKey ? (
        <img
          src={partnerLogoPfad(showcase.partnerLogoKey)}
          alt={name || 'Partner'}
          className={`${gross ? 'h-10 max-w-[16rem]' : 'h-5 max-w-[7rem]'} w-auto object-contain`}
        />
      ) : (
        <span className="font-semibold">{name}</span>
      )}
    </span>
  )
}
